// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext, useRef} from 'react';
import {Lottie, i_lottie_props} from '../lib/lottie';
import {img_url} from '../ui/img_url';
import {t_element_size, use_element_size} from '../lib/screen_util';
// @ts-ignore
import {App_context} from '../context.js';
import {t_element_part, use_screen_position} from '../lib/use_screen_position';

interface i_on_scroll_animation_props extends
    Pick<i_lottie_props, 'src'|'animation'> {
    size: t_element_size;
    cls?: string;
    part?: t_element_part;
    // stop changing frames on scroll when the <part> of the animation
    // reaches <scroll_to_pos> * <screen height> position
    scroll_to_pos: number;
    // change frames on scroll from 0 to <scroll_to_frame>
    scroll_to_frame?: number;
}
export const On_scroll_animation = (props:i_on_scroll_animation_props)=>{
    const {animation, cls, size, src, part = 'center'} = props;
    const {scroll_to_frame = animation[0].frames.from, scroll_to_pos} = props;
    const ref = useRef();
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const screen_pos = use_screen_position<HTMLDivElement>(ref, {rel: true});
    const pos = screen_pos[part];
    const fixed_frame = pos===null ? 0 : pos>=scroll_to_pos ?
        Math.max(Math.round(scroll_to_frame/(1-scroll_to_pos)*(1-pos)), 0) :
        screen_pos.bottom<=0 ? 0 : undefined;
    const [w, h] = use_element_size(size);
    return <div ref={ref} className={cls}>
      {is_client && <Lottie src={img_url(src)} width={w} height={h}
        fixed_frame={fixed_frame} animation={animation}/>}
    </div>;
};
